import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface LegalDocumentsRegistryState {
  document_registry: any
  document_details: any
  edms_file: any
  error: any
}

export interface LegalDocumentFilters {
  page: number
  limit: number
  search: string
  type: string
}

export const useLegalDocumentsRegistryStore = defineStore('legalDocumentsRegistry', {
  state: (): LegalDocumentsRegistryState => ({
    document_registry: null,
    document_details: null,
    edms_file: null,
    error: null,
  }),

  getters: {
    getLegalDocumentRegistry: (state) => state.document_registry,
    getLegalDocumentDetails: (state) => state.document_details,
    getDocumentRegistryError: (state) => state.error,
    getLegalDocumentEDMSFile: (state) => state.edms_file,
  },

  actions: {
    async fetchLegalDocumentsRegistry(data: LegalDocumentFilters) {
      try {
        const response = await api().get('/legal-documents/registry?page=' + data.page + '&per_page=' + data.limit + '&search=' + data.search + '&type=' + data.type)
        this.document_registry = response.data
        this.error = null
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchLegalDocumentDetails(id: string | number) {
      try {
        const response = await api().get('/legal-documents/registry/details?instrumentNumber=' + id)
        this.document_details = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async fetchLegalDocumentEDMSFile(data: any) {
      try {
        const response = await api().post('/integration/api/edms/company/files/all', data)
        this.edms_file = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
